import { reconcileContextCookiesFromCanonical } from "@tSurya/Handlers/SharedCookieContext";

if (reconcileContextCookiesFromCanonical()) {
    window.location.reload();
}